<template>
    <div></div>
</template>
<script>
export default {
    name:'record-info',
    props:{
        title:{
            type:String,
            default:'',
            require:true
        },
        user_id:{
            type:Number,
            default:null
        },
        chapter_name:{
            type:String,
            default:''
        },
        class_id:{
            type:String,
            default:''
        },
        remark:{
            type:String,
            default:''
        }
    },
    data(){
        return {
            start:null,
            end:null,
            userinfo:JSON.parse(localStorage.getItem('userinfo'))
        }
    },
    created(){
        this.start = Date.parse(new Date());
    },
    beforeDestroy(){
        this.end = Date.parse(new Date());
    },
    destroyed(){
        const browsing_time = (this.end - this.start)/1000;
        this.$axios.post('/api/AccessLog/add',{
            data:{
                title:this.title,
                name:this.userinfo.nickname,
                browsing_time,
                user_id:this.user_id,
                chapter_name:this.chapter_name,
                class_id:this.class_id,
                remark:this.remark,
            }
        }).then(res=>{
            // console.log(res);
        }).catch(error=>{
            console.log(error);
        })
    },
}
</script>